import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    end: Number,
    duration: { type: Number, default: 1400 },
    suffix: { type: String, default: "" }
  };

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.element.textContent = `${this.endValue}${this.suffixValue}`;
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || this.started) return;
          this.started = true;
          this.animate();
          this.observer.disconnect();
        });
      },
      { threshold: 0.4 }
    );

    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer?.disconnect();
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  animate() {
    const start = performance.now();
    const from = 0;
    const to = this.endValue;

    const tick = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / this.durationValue, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = Math.round(from + (to - from) * eased);

      this.element.textContent = `${value}${this.suffixValue}`;

      if (progress < 1) {
        this.frame = requestAnimationFrame(tick);
      }
    };

    this.frame = requestAnimationFrame(tick);
  }
}
